import { get, post, put, del } from '../utils/apiUtils';

// No need to use BASE_URL as it's already configured in apiUtils.js
const API_URL = `/api/v1/mms_persistence`;
const API_PIPELINE =`api/v1/bluemormon/pipeline/Pipeline-1767161596197`;



/**
 * Update system settings
 * @param {Object} getWaitingTask - fetch waiting task
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
export const getTemplateCodes = async () => {
  try {
    const response = await post(`${API_URL}/email_template/fetch?skip=0&limit=100`, {
      filter: { status: ['ACTIVE', 'DRAFT'] }
    });
    return response;
  } catch (error) {
    console.error('Error while fetching the template codes:', error);
    throw error;
  }
};


/** 
@param {String} tableName - Table name
@returns {Promise<Object>} Promise resolving to waiting task
*/

export const getEmailList = async (tableName = 'bmm_sl_email_request', filters = {}, sort={}) => {
  try {
    const response = await post(`${API_URL}/${tableName}/fetch?skip=0&limit=10`, {filter: filters, sort});
    return response;
  } catch (error) {
    console.log("Error while fetching the emails", error)
  }
}


/** 
@param {String} tableName - Table name
@returns {Promise<Object>} Promise resolving to waiting task
*/

export const getEmailDetails = async (tableName = 'claim_email_request_mms', filters = {}, sort={}) => {
  try {
    const response = await post(`${API_URL}/${tableName}/fetch?skip=0&limit=10`, {filter: filters, sort});
    return response;
  } catch (error) {
    console.log("Error while fetching the email details", error)
  }
}

//https://product-dev-bluemormon.metamorphosys.co.in/services/api/v1/bluemormon/pipeline/Pipeline-1767161596197%27
/** 
 * 
@returns {Promise<Object>} Promise resolving to waiting task
*/

export const fetchpipeline = async (data, filters = {}, sort={}) => {
  try {
    const response = await post(`${API_PIPELINE}`, data);
    return response;
  } catch (error) {
    console.log("Error while fetching the email details", error)
  }
}
/*
@returns {Promise<Object>} Promise resolving to waiting task
*/

export const fetchPollingData = async (filter = {}, sort={}) => {
  try {
    const response = await post(`${API_URL}/pipeline_execution/fetch`, {filter});
    return response;
  } catch (error) {
    console.log("Error while fetching the email details", error)
  }
}

/**
 * Create a new email template
 * @param {Object} data - Template data
 * @returns {Promise<Object>} Created template record
 */
export const createEmailTemplate = async (data) => {
  try {
    const response = await post(`${API_URL}/email_template`, data);
    return response;
  } catch (error) {
    console.error('Error while creating email template:', error);
    throw error;
  }
};

/**
 * Update an existing email template
 * @param {Object} data - Template data containing id
 * @returns {Promise<Object>} Updated template record
 */
export const updateEmailTemplate = async (data) => {
  try {
    const response = await put(`${API_URL}/email_template`, data);
    return response;
  } catch (error) {
    console.error('Error while updating email template:', error);
    throw error;
  }
};

/**
 * Fetch a single email template by its internal ID
 * @param {string|number} id - Template ID
 * @returns {Promise<Object>} Template record
 */
export const getEmailTemplateById = async (id) => {
  try {
    const response = await post(`${API_URL}/email_template/fetch`, { filter: { id } });
    return response[0] || null;
  } catch (error) {
    console.error('Error while fetching email template by ID:', error);
    throw error;
  }
};

/**
 * Fetch a single email template by its unique code
 * @param {string} code - Template code (e.g. TEMP-xxx)
 * @returns {Promise<Object>} Template record
 */
export const getEmailTemplateByCode = async (code) => {
  try {
    const response = await post(`${API_URL}/email_template/fetch`, { filter: { code } });
    return response[0] || null;
  } catch (error) {
    console.error('Error while fetching email template by Code:', error);
    throw error;
  }
};

/**
 * Fetch email templates with filtering and pagination
 * @param {Object} filter - Filter criteria
 * @param {Object} sort - Sort criteria
 * @param {Object} query - skip and limit criteria
 * @returns {Promise<Array>} List of email templates
 */
export const getEmailTemplates = async (filter = {}, sort = {}, query = { skip: 0, limit: 10 }) => {
  try {
    const skip = query.skip ?? 0;
    const limit = query.limit ?? 10;
    const response = await post(`${API_URL}/email_template/fetch?skip=${skip}&limit=${limit}`, { filter, sort });
    return response;
  } catch (error) {
    console.error('Error while fetching email templates:', error);
    throw error;
  }
};

/**
 * Fetch total count of email templates matching filter
 * @param {Object} filter - Filter criteria
 * @returns {Promise<number>} Total count
 */
export const getEmailTemplateCount = async (filter = {}) => {
  try {
    const response = await post(`${API_URL}/email_template/count`, filter);
    return response.count;
  } catch (error) {
    console.error('Error while fetching email template count:', error);
    throw error;
  }
};

/**
 * Delete / Archive an email template by ID
 * @param {string|number} id - Template ID to delete
 * @returns {Promise<Object>} Deletion result
 */
export const deleteEmailTemplate = async (id) => {
  try {
    const response = await del(`${API_URL}/email_template/${id}`);
    return response;
  } catch (error) {
    console.error('Error while deleting email template:', error);
    throw error;
  }
};



